import Skeleton from '@mui/material/Skeleton';

export default function SkeletonMiniBook() {
    return (
        <div 
            className="flex flex-col w-full bg-white dark:bg-slate-900 rounded-[15px] shadow-md overflow-hidden border border-gray-100 dark:border-slate-800 animate-pulse"
            style={{ maxWidth: '350px', minHeight: '320px' }}
        >
            {/* 1. Área da Imagem (Simulando o container do gradiente) */}
            <div className="relative flex justify-center items-center p-6 h-[200px] bg-gray-100 dark:bg-slate-800">
                <Skeleton 
                    variant="rounded" 
                    width={90} 
                    height={140} 
                    sx={{ bgcolor: 'grey.400', borderRadius: '4px' }}
                />
                
                {/* Badge de Status Fake */}
                <div className="absolute top-3 left-3">
                    <Skeleton variant="rounded" width={60} height={18} sx={{ borderRadius: '12px', bgcolor: 'grey.500' }} />
                </div>
            </div>

            {/* 2. Rodapé de Informações */}
            <div className="p-4 flex flex-col justify-between flex-1">
                <div>
                    {/* Título e Autor */}
                    <Skeleton variant="text" width="80%" height={24} sx={{ bgcolor: 'grey.400' }} />
                    <Skeleton variant="text" width="50%" height={18} sx={{ bgcolor: 'grey.400', mt: 0.5 }} />

                    {/* Grid de Datas */}
                    <div className="grid grid-cols-2 gap-4 mt-4 pt-2 border-t border-gray-50 dark:border-slate-800">
                        <div>
                            <Skeleton variant="text" width={40} height={12} sx={{ bgcolor: 'grey.500' }} />
                            <Skeleton variant="text" width={60} height={18} sx={{ bgcolor: 'grey.400' }} />
                        </div>
                        <div>
                            <Skeleton variant="text" width={40} height={12} sx={{ bgcolor: 'grey.500' }} />
                            <Skeleton variant="text" width={60} height={18} sx={{ bgcolor: 'grey.400' }} />
                        </div>
                    </div>
                </div>

                {/* Botões Fakes */}
                <div className="flex gap-2 mt-4">
                    <Skeleton variant="rounded" width="100%" height={32} sx={{ borderRadius: '8px', bgcolor: 'grey.500' }} />
                    <Skeleton variant="rounded" width="100%" height={32} sx={{ borderRadius: '8px', bgcolor: 'grey.500' }} />
                </div>
            </div>
        </div>
    )
}